module.exports = __webpack_public_path__ + "static/media/3.70842413.svg";